import { render, staticRenderFns } from "./project_details2.vue?vue&type=template&id=54821ed9&scoped=true&"
import script from "./project_details2.vue?vue&type=script&lang=js&"
export * from "./project_details2.vue?vue&type=script&lang=js&"
import style0 from "./project_details2.vue?vue&type=style&index=0&id=54821ed9&lang=scss&scoped=true&"
import style1 from "./project_details2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54821ed9",
  null
  
)

export default component.exports